import { render, staticRenderFns } from "./DiseaseInfoEdit.vue?vue&type=template&id=9e79d828&scoped=true&"
import script from "./DiseaseInfoEdit.vue?vue&type=script&lang=js&"
export * from "./DiseaseInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e79d828",
  null
  
)

export default component.exports